import React from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Divider,
  Stack
} from "@mui/material";
import { Phone, Email, LocationOn } from "@mui/icons-material";

const Resume36 = ({
  color = "#4a4a4a", // Default color
  font = "Inter, Roboto, sans-serif",
  fontSize = "12.5px",
  headingSize = "13px",
  pageSize = "A4",
}) => {

  const SectionTitle = ({ title }) => (
    <Box
      sx={{
        border: `1px solid ${color}`,
        borderRadius: "20px",
        px: 3,
        py: 0.6,
        display: "inline-block",
        mb: 2
      }}
    >
      <Typography
        sx={{
          fontSize: "13px",
          fontWeight: 700,
          letterSpacing: 1,
          textTransform: "uppercase",
          color: color
        }}
      >
        {title}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        width: {lg:"210mm",xs:"175mm"},
        minHeight: "297mm",
        mx: "auto",
        bgcolor: "#fff",
        p: "18mm",
        fontFamily: font,
        boxShadow: "0 0 12px rgba(0,0,0,.15)"
      }}
    >
      {/* HEADER - Uses the color prop */}
      <Box
        sx={{
          bgcolor: color,
          borderRadius: 3,
          p: 3,
          display: "flex",
          alignItems: "center",
          gap: 3,
          color: "#fff",
          mb: 4,
          width: "600px",
        }}
      >
        <Avatar
          src="https://via.placeholder.com/150"
          sx={{ width: 90, height: 90 }}
        />
        <Box>
          <Typography variant="h5" fontWeight={700}>
            Lorna Alvarado
          </Typography>
          <Typography fontSize="14px" sx={{ opacity: 0.9 }}>
            Marketing Manager
          </Typography>
        </Box>
      </Box>

      {/* BODY */}
      <Grid container spacing={4}>
        {/* LEFT COLUMN */}
        <Grid item sx={{ width: "230px" }}>
          <SectionTitle title="About Me" />
          <Typography fontSize={fontSize} mb={3}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Egestas accumsan nunc enim.
          </Typography>

          <Stack spacing={1} mb={4}>
            <Typography fontSize={fontSize}>
              <Phone sx={{ fontSize: 14, mr: 1, color: color }} /> +123 456 7890
            </Typography>
            <Typography fontSize={fontSize}>
              <Email sx={{ fontSize: 14, mr: 1, color: color }} /> hello@reallygreatsite.com
            </Typography>
            <Typography fontSize={fontSize}>
              <LocationOn sx={{ fontSize: 14, mr: 1, color: color }} /> Any City, Any Country
            </Typography>
          </Stack>

          <SectionTitle title="Education" />
          <Typography fontWeight={600} fontSize={fontSize}>
            Master of Business
          </Typography>
          <Typography fontSize="12px" mb={2}>
            Wardiere University (2011 – 2015)
          </Typography>

          <SectionTitle title="Skills" />
          <ul style={{ 
            paddingLeft: 18, 
            fontSize: fontSize,
            color: "#333"
          }}>
            {[
              "Management Skills",
              "Creativity",
              "Digital Marketing",
              "Negotiation",
              "Leadership"
            ].map(skill => (
              <li key={skill} style={{ marginBottom: "4px" }}>{skill}</li>
            ))}
          </ul>
        </Grid>

        {/* RIGHT COLUMN */}
        <Grid item sx={{ width: "380px" }}>
          <SectionTitle title="Experience" />

          {[
            { 
              year: "2020 – 2023", 
              role: "Product Design Manager", 
              company: "Arowwai Industries" 
            },
            { 
              year: "2019 – 2020", 
              role: "Marketing Manager", 
              company: "Arowwai Industries" 
            },
            { 
              year: "2017 – 2019", 
              role: "Marketing Manager", 
              company: "Arowwai Industries" 
            }
          ].map((exp, i) => (
            <Box key={i} mb={2}>
              <Box display="flex" justifyContent="space-between">
                <Typography fontWeight={600} fontSize={headingSize}>
                  {exp.role}
                </Typography>
                <Typography fontSize={fontSize} color={color}>
                  {exp.year}
                </Typography>
              </Box>
              <Typography fontSize={fontSize} color="gray">
                {exp.company}
              </Typography>
              <Divider sx={{ 
                mt: 1, 
                borderColor: color,
                opacity: 0.3 
              }} />
            </Box>
          ))}

          <SectionTitle title="References" />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography 
                fontWeight={600} 
                fontSize={fontSize}
                color={color}
              >
                Harumi Kobayashi
              </Typography>
              <Typography fontSize="12px">Wardiere Inc.</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography 
                fontWeight={600} 
                fontSize={fontSize}
                color={color}
              >
                Bailey Dupont
              </Typography>
              <Typography fontSize="12px">Wardiere Inc.</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Resume36;
export const resumeMeta = {
  hasPhoto: true,
  columns: 2,
  colorOptions: [
    { value: '#4a4a4a', label: 'Dark Gray' },
    { value: '#2196f3', label: 'Blue' },
    { value: '#4caf50', label: 'Green' },
    { value: '#ff9800', label: 'Orange' },
    { value: '#9c27b0', label: 'Purple' },
    { value: '#f44336', label: 'Red' }
  ]
};